<!--sidebar-->
<c-sidebar #sidebar1="cSidebar" class="d-print-none sidebar sidebar-fixed bg-dark-gradient border-end"
  colorScheme="dark" id="sidebar1" visible>
  <c-sidebar-header class="border-bottom">
    <c-sidebar-brand cSidebarToggle="sidebar1" toggle="unfoldable" style="cursor: pointer;">
      <img src="assets/brand/logo-cambios-polar.png" alt="Logo" class="sidebar-brand-full" height="40"
        style="justify-content: center;" />
    </c-sidebar-brand>
    <button cSidebarToggle="sidebar1" cButtonClose class="d-lg-none" dark toggle="visible">
    </button>
    <button cSidebarToggler="sidebar1" toggle="unfoldable"></button>
  </c-sidebar-header>

  <ng-scrollbar #scrollbar="ngScrollbar" (updated)="onScrollbarUpdate(scrollbar.state)" class="overflow"
    pointerEventsMethod="scrollbar" visibility="hover">
    <c-sidebar-nav #overflow [navItems]="routes()" dropdownMode="close" compact>
      <ng-template let-item let-i="index" #iconTemplate>
        <ng-container *ngIf="item.icon && icons[item.icon]">
          <svg [cIcon]="icons[item.icon]"></svg>
        </ng-container>
      </ng-template>
    </c-sidebar-nav>
  </ng-scrollbar>
</c-sidebar>

<!--main-->
<div class="wrapper d-flex flex-column min-vh-100">
  <!-- Imagen de fondo en HTML (fallback visible inmediatamente). Si es decorativa, alt vacío -->
  <div class="layout-bg" aria-hidden="true">
    <img src="assets/images/Grupo-45.png" alt="" loading="lazy" />
  </div>
  <div class="layout-bg" aria-hidden="true">
    <img src="assets/images/Grupo-45.jpg" alt="" loading="lazy" />
  </div>
  <!--app-header-->
  <app-default-header [cShadowOnScroll]="'sm'" class="mb-4 d-print-none header header-sticky p-0 shadow-sm"
    position="sticky" sidebarId="sidebar1" />
  <!--app-body-->
  <div class="body flex-grow-1">
    <c-container breakpoint="lg" class="h-auto px-4">
      <app-default-breadcrumb />
      <router-outlet />
    </c-container>
  </div>
  <!--app footer-->
  <app-default-footer />
</div>

<!--aside-->
<app-default-aside style="display: none;" />

<!--POLAR-751: aviso de inactividad de sesion-->
<app-session-timeout-modal />